import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EventDetailsModule } from '../event-details/event-details.module';
import { EventcategoryController } from './eventcategory.controller';
import { EventscategoryEntity } from './eventcategory.entity';
import { EventcategoryService } from './eventcategory.service';

@Module({
    imports: [
        TypeOrmModule.forFeature([EventscategoryEntity]),
    ],
    controllers:[EventcategoryController],
    providers:[EventcategoryService],
    exports:[EventcategoryService],
})
export class EventscategoryModule {}